import { render, staticRenderFns } from "./buddyApiKeysCreate.popup-chunk.vue?vue&type=template&id=498eba10&scoped=true"
import script from "./buddyApiKeysCreate.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./buddyApiKeysCreate.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./buddyApiKeysCreate.popup-chunk.vue?vue&type=style&index=0&id=498eba10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498eba10",
  null
  
)

export default component.exports